import { useCallback } from "react";
import { ChoiceButton } from "@ww-digital/web-foundations-react/modules";

import t, { AsHtml } from "../../../../../utils/translate";
import Column from "../../../../Column";
import { TERMS_AND_CONDITIONS } from "../../../constants";

import styles from "./styles.module.scss";

const TermsConditions = ({ termsConditionsAgreement, onChange, plan }) => {
  const getTerms = useCallback(() => {
    const termsAndConditionsPrefix = t(
      "CHECKOUT_ACKNOWLEDGEMENT_TERMS_PRODUCT_CLINICAL_HTML_3"
    );
    const termsAndConditions =
      plan.templateContentMap?.get(TERMS_AND_CONDITIONS);

    const terms = termsAndConditions ? (
      <AsHtml
        className={styles.conditions}
        value={`${termsAndConditionsPrefix} ${termsAndConditions}`}
        tagType="div"
      />
    ) : null;

    return (
      <Column className={styles.terms}>
        {terms && (
          <ChoiceButton
            type="checkbox"
            name="termsConditions"
            value={termsConditionsAgreement}
            description={terms}
            checked={termsConditionsAgreement}
            onChange={onChange}
            className={styles.checkbox}
          />
        )}
      </Column>
    );
  }, [termsConditionsAgreement]);

  return <>{getTerms()}</>;
};

export default TermsConditions;
